// extracted by mini-css-extract-plugin
export default {"scoreComponent":"rangeinput__scoreComponent-HvrX_","scoreValue":"rangeinput__scoreValue-ugzuZ"};